import React, {useState} from 'react'
import {Row} from 'antd'
import 'dayjs/locale/ru';
import Constructor from "../index";
import {useTranslation} from "react-i18next";
import {useParams} from "react-router-dom";
import '../style.css'
import Back from "../back";

const ConstructorCostBase = () => {
    const [viewBlock, setViewBlock] = useState('default')
    const {t} = useTranslation(['kit'])
    const routeParams = useParams()
    const id = routeParams?.id
    return (
        <div className='designer'>
            {viewBlock === "default" &&
            <Row align='middle' justify='space-between'>
                <Back url={'/'} title={t('kit:confExitConstructor')}/>
                {/*<BrdCrumb routes={[['', t("common:back")]]}/>*/}
                <h3 className="title-name" style={{}}>
                    Конструктор, стоимостной метод. {(id) ? t('kit:editCustomObj') : t('kit:createCustomObj')}
                </h3>
                <div/>
            </Row>}
            <Constructor
                setViewBlock={setViewBlock}
                viewBlock={viewBlock}
                isResource={false}
                id={id}
            />
        </div>
    );
};

export default ConstructorCostBase
